import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowPreviousSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.414 4.414 4.828 8l3.586 3.586L7 13 2 8l5-5 1.414 1.414Zm5.586 0L10.414 8 14 11.586 12.586 13l-5-5 5-5L14 4.414Z"
    />
  </svg>
);
export default IconArrowPreviousSizeS;
